import React from 'react';
import { t, TFunction } from 'i18next';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { RealtimeMetric } from '../UniversalDataMapper/UniversalDeviceDataMapper';
import { SliderPoint } from '../ControlCenterCompressorWidget/DetailsWidgetSlider/DetailsWidgetSlider.types';
import { metricsDetails } from '@/constants';
import { DEFAULT_SCC_DEVICE_UI_META, SCC_DEVICE_UI_MAP } from '@/comp/StationControlCenter/config/device-ui-map';

export type BottomMetric = {
  label: React.ReactNode;
  value: React.ReactNode;
};

export type DeviceIconAndLabel = {
  icon: React.ReactNode;
  label: string;
};

type GetSliderPointsArgs = {
  metric?: RealtimeMetric;
  t: TFunction;
  tvalue: (value: number, unit?: string) => number;
};

export const getDeviceIconAndLabel = (deviceType: DeviceType): DeviceIconAndLabel => {
  const meta = SCC_DEVICE_UI_MAP[deviceType] ?? DEFAULT_SCC_DEVICE_UI_META;
  return {
    icon: meta.icon,
    label: t(meta.label),
  };
};

export const getLabelByKey = (metric: string): string => {
  return metricsDetails[metric]?.text;
};

export const getSliderPointsFromMetric = ({ metric, t, tvalue }: GetSliderPointsArgs): SliderPoint[] => {
  if (!metric?.additionalContext) return [];

  const points: SliderPoint[] = [];

  if (metric.additionalContext.min) {
    points.push({
      value: tvalue(metric.additionalContext.min.value, metric.unit),
      label: t('LOAD'),
    });
  }

  if (metric.additionalContext.max) {
    points.push({
      value: tvalue(metric.additionalContext.max.value, metric.unit),
      label: t('UNLOAD'),
    });
  }

  if (metric.additionalContext.target !== undefined) {
    points.push({
      value: tvalue(Number(metric.additionalContext.target), metric.unit),
      label: t('Target'),
      highlighted: true,
      isTarget: true,
    });
  }

  return points;
};
